export const getWebRTCToken = async (accountId: number) => {
  const url = `${process.env.REACT_APP_SIGNALLING_API_URL}/accounts/${accountId}/genesys-audio-webrtc-token`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({}),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data.token;
  } catch (error) {
    console.error('Failed to fetch WebRTC token:', error);
    throw error;
  }
};
